// EditPDF.js
import React from 'react';
import { PDFDocument, rgb } from 'pdf-lib';

const EditPDF = () => {
  const handleEditPDF = async () => {
    // Load an existing PDF from a URL or local file
    const existingPdfBytes = await fetch('/sample.pdf').then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // Draw text on the first page
    firstPage.drawText('Hello !', {
      x: 50,
      y: 700,
      size: 24,
      color: rgb(0, 0.53, 0.71),
    });

    // Serialize the PDF
    const pdfBytes = await pdfDoc.save();

    // Trigger download
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'edited.pdf';
    link.click();
  };

  return (
    <div>
      <div>
        <button onClick={handleEditPDF}>Edit and Download PDF</button>
      </div>
     
    </div>
  );
};

export default EditPDF;
// EditPDF.js